export default __webpack_public_path__ + "static/media/searchIcon.f6bf637e.svg";